import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import EditIcon from "@mui/icons-material/Edit";
import { Button } from "@mui/material";
import useAuth from "../../hooks/useAuth";

const ManageProfile = () => {
  const navigate = useNavigate();
  const user = useAuth();

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Profile</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Profile
        </p>
      </div>

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>General Details</h2>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-profile/edit")}
            >
              <EditIcon /> Edit Profile
            </Button>
          </div>
        </div>
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img
                alt="user"
                src={user?.image || "/static/images/user_placeholder.png"}
              />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{user?.name || ""}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{user?.email || ""}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>
              {`${user?.countryCode || ""}` + " " + user?.phoneNumber || ""}
            </p>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default ManageProfile;
